import React from 'react';
import '../styles/CordycepsSection.css';

const CordycepsSection = () => {
  return (
    <section id="cordyceps" className="cordyceps-section section-padding">
      <div className="container">
        <div className="cordyceps-grid">
          <div className="cordyceps-image-wrapper">
            <img 
              src="https://customer-assets.emergentagent.com/job_adapt-wellness/artifacts/4a81jhpm_WhatsApp%20Image%202026-01-29%20at%2013.30.37.jpeg" 
              alt="Cordyceps Militaris Mushroom"
              className="cordyceps-image"
            />
          </div>
          <div className="cordyceps-content">
            <h2 className="heading-1">
              Cordyceps Militaris<br />
              <span className="accent-orange">Nature's Energy Catalyst</span>
            </h2>
            <div className="cordyceps-text">
              <h3 className="heading-3">Ancient Wisdom</h3>
              <p className="body-regular">
                For centuries, Cordyceps militaris has been revered in traditional Chinese and Tibetan medicine as a powerful adaptogen. Used by ancient healers to enhance stamina, vitality, and longevity, this remarkable mushroom was reserved for emperors and elite athletes seeking peak performance.
              </p>
            </div>
            <div className="cordyceps-text">
              <h3 className="heading-3">Modern Validation</h3>
              <p className="body-regular">
                Today, contemporary science validates what ancient practitioners knew intuitively. Research demonstrates Cordyceps militaris' remarkable bioactive compounds — particularly cordycepin and adenosine — that support cellular energy production, oxygen utilization, and overall vitality. Our lab-grown Cordyceps ensures consistent potency and purity that nature alone cannot guarantee.
              </p>
            </div>
            <div className="cordyceps-potency">
              <div className="potency-item">
                <span className="potency-label">Cordycepin</span>
                <span className="potency-value accent-orange">10.27 mg/gm</span>
              </div>
              <div className="potency-item">
                <span className="potency-label">Adenosine</span>
                <span className="potency-value accent-orange">1.98 mg/gm</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CordycepsSection;